export default "__VITE_ASSET__DQYOTiPU__"